import React, { useEffect, useRef, useState } from "react";

const FeaturedVisualization = ({ provocationText, visualizationCode, theme }) => {
  const iframeRef = useRef(null);
  const [isSourceVisible, setIsSourceVisible] = useState(false);

  useEffect(() => {
    // When new visualization code is received, send it to the iframe
    if (iframeRef.current) {
      // A short delay ensures the iframe is ready
      setTimeout(() => {
        iframeRef.current.contentWindow.postMessage(
          { code: visualizationCode, theme: theme },
          "*"
        );
      }, 500);
    }
  }, [visualizationCode, theme]);

  // If there's no provocation text, don't render anything
  if (!provocationText) {
    return null;
  }

  const toggleSourceVisibility = () => {
    setIsSourceVisible(!isSourceVisible);
  };

  return (
    <div className="mt-8 p-4 bg-white dark:bg-gray-800 rounded-lg shadow-xl">
      <h3 className="font-bold text-lg mb-2 text-gray-900 dark:text-white">Remixed Visualization</h3>
      <p className="italic text-gray-500 dark:text-gray-400 mb-4">"{provocationText}"</p>
      <div className="border-2 border-gray-200 dark:border-primary-500 rounded-md bg-white dark:bg-black overflow-hidden w-full h-[32rem] mb-4">
        <iframe
          ref={iframeRef}
          src="/p5-runner.html"
          title="Featured p5.js Sketch Runner"
          className="w-full h-full border-0"
          sandbox="allow-scripts"
          key={provocationText} // Use the text as a key to force re-render
        />
      </div>
      <button
        onClick={toggleSourceVisibility}
        className="text-sm text-gray-500 dark:text-gray-400 hover:text-gray-800 dark:hover:text-white hover:underline"
      >
        {isSourceVisible ? "Hide Source" : "View Source"}
      </button>
      {isSourceVisible && (
        <div className="mt-4 p-4 bg-gray-100 dark:bg-black rounded-md overflow-x-auto">
          <pre className="text-sm text-gray-800 dark:text-gray-200 whitespace-pre-wrap">
            <code>{visualizationCode}</code>
          </pre>
        </div>
      )}
    </div>
  );
};

export default FeaturedVisualization;
